import { ApiVersions } from '../api-versions';
import type { InternalGetRolePresetsOpenAPIQueryParams } from '../generated/operations/raw-openapi-query-params-for-serializers';

export const apiVersion = ApiVersions.V4;

export type InternalGetRolePresetsQueryParams = InternalGetRolePresetsOpenAPIQueryParams & {
  expand?: 'roleTemplates';
};

export function querySerializer(queryParams: InternalGetRolePresetsQueryParams) {
  const searchParams = new URLSearchParams();

  if (queryParams.expand) {
    searchParams.set('expand', queryParams.expand);
  }

  return searchParams.toString();
}
